import React from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';

const Buy2BHKVasundharaPage = () => {
  const navigate = useNavigate();

  const faqs = [
    {
      question: "What is the average price of a 2BHK flat in Vasundhara?",
      answer: "2BHK flats in Vasundhara range from ₹48-85 lakhs. Premium projects like Mahagun Moderne cost ₹70-85L, while Supertech Ecovillage offers options in the ₹50-65L range. Newer developments command premium over older societies."
    },
    {
      question: "Why choose 99prop.com over traditional property brokers?",
      answer: "99prop.com is a direct buying platform that eliminates the 1-2% brokerage fee (₹50,000-₹1.7L on a ₹85L flat). We own select inventory or have exclusive agreements, providing you with zero-commission deals, free advisory, and faster closures (7-15 days)."
    },
    {
      question: "Is Vasundhara good for 2BHK investment in 2026?",
      answer: "Yes, Vasundhara shows strong investment potential with upcoming metro connectivity, modern infrastructure, and 6-9% annual appreciation in premium segments. Rental yields of 3.5-4% make it attractive for both capital gains and rental income investors."
    },
    {
      question: "Which are the top societies for 2BHK in Vasundhara?",
      answer: "Top picks: Mahagun Moderne (₹70-85L, luxury), Saviour Park (₹65-75L, premium amenities), Ajnara Daffodil (₹60-70L, well-maintained), Supertech Ecovillage (₹55-65L, township), and Purvanchal Royal Park (₹50-60L, value option)."
    },
    {
      question: "How is the rental market for 2BHK flats in Vasundhara?",
      answer: "Vasundhara has a growing rental market with yields of 3.5-4%. 2BHK units rent for ₹16,000-26,000/month depending on society and furnishing. Demand comes from IT professionals working in nearby Noida and Delhi offices."
    },
    {
      question: "What are the additional costs when buying 2BHK in Vasundhara?",
      answer: "Budget for: stamp duty & registration (1%), society transfer fee (₹30,000-60,000), legal verification (₹10,000-20,000), and home loan processing (0.5-1% if taking loan). With 99prop.com, you save the biggest cost—brokerage (1-2%)."
    }
  ];

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": { "@type": "Answer", "text": faq.answer }
    }))
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "RealEstateAgent",
    "name": "99Prop",
    "url": "https://99prop.com",
    "telephone": "+91-9891979097",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Vasundhara",
      "addressRegion": "Ghaziabad",
      "addressCountry": "IN"
    },
    "priceRange": "₹45L - ₹80L",
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "reviewCount": "520"
    }
  };

  return (
    <>
      <Helmet>
        <title>Buy 2BHK in Vasundhara | Zero Brokerage | Direct Deals</title>
        <meta name="description" content="Buy 2BHK flats in Vasundhara from ₹48-85L. Zero brokerage, direct buying, expert advisory. Mahagun, Saviour Park properties. 99prop.com" />
        <meta name="keywords" content="buy 2BHK Vasundhara, 2BHK flat Vasundhara, property in Vasundhara, Mahagun Moderne, Saviour Park, zero brokerage" />
        <link rel="canonical" href="https://99prop.com/buy-2bhk-in-vasundhara" />
        <meta property="og:title" content="Buy 2BHK in Vasundhara | Zero Brokerage | Direct Deals" />
        <meta property="og:description" content="Buy 2BHK flats in Vasundhara from ₹48-85L. Zero brokerage, direct buying, expert advisory." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://99prop.com/buy-2bhk-in-vasundhara" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(localBusinessSchema) }} />
      
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />

      <div className="min-h-screen bg-gray-50">
        <div className="bg-gradient-to-r from-brand-500 to-brand-700 py-16 sm:py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6">Buy 2BHK in Vasundhara</h1>
            <p className="text-xl sm:text-2xl text-brand-100 mb-8 max-w-3xl mx-auto">
              Direct Buying | Zero Brokerage | Expert Advisory | ₹48L-₹85L
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button onClick={() => navigate('/buy-property')} className="bg-white text-brand-600 px-8 py-4 rounded-lg font-bold text-lg hover:bg-gray-100 transition shadow-xl">
                View Available Properties
              </button>
              <a href="tel:+919891979097" className="bg-brand-800 text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-brand-900 transition shadow-xl">
                Call: +91 9891 97 90 97
              </a>
            </div>
          </div>
        </div>

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <article className="bg-white rounded-2xl shadow-lg p-8 sm:p-12 space-y-8">
            
            <section>
              <p className="text-lg text-gray-700 leading-relaxed">
                Looking to <strong>buy 2BHK in Vasundhara</strong> without paying hefty brokerage? 99prop.com is your direct buying platform—not a listing portal. We own select properties and maintain exclusive builder agreements, which means zero commission for you. Whether you're seeking luxury at Mahagun Moderne or value at Supertech Ecovillage, we offer curated inventory with complete transparency and expert investment guidance.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">2BHK Price Trends in Vasundhara (2026)</h2>
              <div className="bg-brand-50 p-6 rounded-xl space-y-3">
                <div className="border-l-4 border-brand-500 pl-4">
                  <h3 className="text-lg font-bold text-gray-900">Budget: ₹58-70 Lakhs</h3>
                  <p className="text-gray-700">Purvanchal Royal Park, older Supertech projects. Entry-level options.</p>
                </div>
                <div className="border-l-4 border-brand-500 pl-4">
                  <h3 className="text-lg font-bold text-gray-900">Budget: ₹72-84 Lakhs</h3>
                  <p className="text-gray-700">Ajnara Daffodil, Supertech Ecovillage. Good balance of price and amenities.</p>
                </div>
                <div className="border-l-4 border-brand-500 pl-4">
                  <h3 className="text-lg font-bold text-gray-900">Budget: ₹84-102 Lakhs</h3>
                  <p className="text-gray-700">Mahagun Moderne, Saviour Park. Premium lifestyle with modern amenities.</p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Best Societies to Buy 2BHK in Vasundhara</h2>
              <div className="space-y-6">
                <div className="bg-gray-50 p-6 rounded-xl">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">1. Mahagun Moderne</h3>
                  <p className="text-gray-700 mb-2"><strong>Price Range:</strong> ₹84-102 Lakhs | <strong>Size:</strong> 1,200-1,400 sq.ft</p>
                  <p className="text-gray-700">Luxury living with premium amenities, excellent build quality, strong appreciation potential.</p>
                </div>
                <div className="bg-gray-50 p-6 rounded-xl">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">2. Saviour Park</h3>
                  <p className="text-gray-700 mb-2"><strong>Price Range:</strong> ₹78-90 Lakhs | <strong>Size:</strong> 1,100-1,300 sq.ft</p>
                  <p className="text-gray-700">Premium society with excellent maintenance, clubhouse, and strong community.</p>
                </div>
                <div className="bg-gray-50 p-6 rounded-xl">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">3. Ajnara Daffodil</h3>
                  <p className="text-gray-700 mb-2"><strong>Price Range:</strong> ₹72-84 Lakhs | <strong>Size:</strong> 1,050-1,250 sq.ft</p>
                  <p className="text-gray-700">Well-maintained society with good connectivity, popular among working professionals.</p>
                </div>
                <div className="bg-gray-50 p-6 rounded-xl">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">4. Supertech Ecovillage</h3>
                  <p className="text-gray-700 mb-2"><strong>Price Range:</strong> ₹66-78 Lakhs | <strong>Size:</strong> 1,000-1,200 sq.ft</p>
                  <p className="text-gray-700">Township living with schools, parks, and commercial areas within complex.</p>
                </div>
              </div>
            </section>

            <section className="bg-gradient-to-r from-brand-500 to-brand-600 p-8 rounded-xl text-center">
              <h3 className="text-2xl font-bold text-white mb-4">Explore Available 2BHK Properties</h3>
              <p className="text-brand-100 mb-6">Zero brokerage. Direct buying. Expert guidance.</p>
              <button onClick={() => navigate('/buy-property')} className="bg-white text-brand-600 px-8 py-4 rounded-lg font-bold text-lg hover:bg-gray-100 transition shadow-xl">
                View Properties
              </button>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Pros and Cons of Buying 2BHK in Vasundhara</h2>
              <div className="grid md:grid-cols-2 gap-6">
                <div className="bg-green-50 p-6 rounded-xl">
                  <h3 className="text-xl font-bold text-green-800 mb-4">✅ Pros</h3>
                  <ul className="space-y-2 text-gray-700">
                    <li className="flex items-start gap-2"><span className="text-green-600 font-bold">•</span><span><strong>Modern Societies:</strong> Newer construction with contemporary designs</span></li>
                    <li className="flex items-start gap-2"><span className="text-green-600 font-bold">•</span><span><strong>Upcoming Metro:</strong> Planned connectivity will boost values</span></li>
                    <li className="flex items-start gap-2"><span className="text-green-600 font-bold">•</span><span><strong>NH-24 Access:</strong> Quick access to Delhi and Noida</span></li>
                    <li className="flex items-start gap-2"><span className="text-green-600 font-bold">•</span><span><strong>High Appreciation:</strong> 6-9% annually in premium segments</span></li>
                    <li className="flex items-start gap-2"><span className="text-green-600 font-bold">•</span><span><strong>Premium Amenities:</strong> Modern facilities in top societies</span></li>
                  </ul>
                </div>
                <div className="bg-orange-50 p-6 rounded-xl">
                  <h3 className="text-xl font-bold text-orange-800 mb-4">⚠️ Cons</h3>
                  <ul className="space-y-2 text-gray-700">
                    <li className="flex items-start gap-2"><span className="text-orange-600 font-bold">•</span><span><strong>Metro Still Pending:</strong> Current metro access requires travel</span></li>
                    <li className="flex items-start gap-2"><span className="text-orange-600 font-bold">•</span><span><strong>Less Mature:</strong> Fewer established amenities vs Indirapuram</span></li>
                    <li className="flex items-start gap-2"><span className="text-orange-600 font-bold">•</span><span><strong>Higher Maintenance:</strong> Premium societies charge ₹4-7/sq.ft</span></li>
                    <li className="flex items-start gap-2"><span className="text-orange-600 font-bold">•</span><span><strong>Construction Noise:</strong> Some areas still under development</span></li>
                  </ul>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Investment Potential of 2BHK in Vasundhara</h2>
              <div className="space-y-4">
                <div className="border-l-4 border-brand-500 pl-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Capital Appreciation: 6-9% Annually</h3>
                  <p className="text-gray-700">Premium societies show strong growth. A ₹70L property could be worth ₹100-115L in 5 years.</p>
                </div>
                <div className="border-l-4 border-brand-500 pl-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Rental Yield: 3.5-4% Per Annum</h3>
                  <p className="text-gray-700">2BHK units command ₹16,000-26,000 monthly rent. Annual income: ₹1.9-3.1L on a ₹55-75L investment.</p>
                </div>
                <div className="border-l-4 border-brand-500 pl-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Future Growth Catalyst</h3>
                  <p className="text-gray-700">Planned metro connectivity will significantly boost property values, making early entry advantageous.</p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Why Buying Direct Eliminates Brokerage</h2>
              <div className="space-y-6">
                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-brand-500 text-white rounded-full flex items-center justify-center font-bold text-xl">1</div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-1">No Intermediaries</h3>
                    <p className="text-gray-700">We own or have exclusive agreements on properties—direct dealing means zero brokerage.</p>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-brand-500 text-white rounded-full flex items-center justify-center font-bold text-xl">2</div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-1">Save ₹50,000-₹1,70,000</h3>
                    <p className="text-gray-700">Typical brokerage on ₹50-85L properties. Keep that money for interiors or furnishing.</p>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-brand-500 text-white rounded-full flex items-center justify-center font-bold text-xl">3</div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-1">Complete Investment Analysis</h3>
                    <p className="text-gray-700">Free ROI projections, legal verification, home loan coordination—all included.</p>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-brand-500 text-white rounded-full flex items-center justify-center font-bold text-xl">4</div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-1">Fast 7-15 Day Closures</h3>
                    <p className="text-gray-700">Direct buying eliminates negotiation delays. Documentation to possession in under 2 weeks.</p>
                  </div>
                </div>
              </div>
            </section>

            <section className="bg-gray-50 p-6 rounded-xl">
              <h3 className="text-xl font-bold text-gray-900 mb-4">Related Resources</h3>
              <ul className="space-y-2">
                <li><a href="/buy-property" className="text-brand-600 font-semibold hover:underline">→ Browse All Available Properties</a></li>
                <li><a href="/?start=true" className="text-brand-600 font-semibold hover:underline">→ Free Property Valuation Tool</a></li>
                <li><a href="/sell-flat-in-vasundhara" className="text-brand-600 font-semibold hover:underline">→ Selling Property in Vasundhara?</a></li>
                <li><a href="/buyer-strategy" className="text-brand-600 font-semibold hover:underline">→ Get Personalized Buyer Strategy</a></li>
              </ul>
            </section>

            {/* WhatsApp CTA */}
            <section className="bg-gradient-to-r from-green-500 to-green-600 p-8 rounded-xl text-center">
              <h3 className="text-2xl font-bold text-white mb-3">Get Instant Quote on WhatsApp</h3>
              <p className="text-green-100 mb-6">Response under 5 minutes</p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a href="https://wa.me/919891979097?text=Hi, interested in 2BHK Vasundhara" target="_blank" rel="noopener noreferrer" className="bg-white text-green-600 px-8 py-4 rounded-lg font-bold text-lg hover:bg-gray-100 transition shadow-xl inline-flex items-center justify-center gap-2">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
                  WhatsApp Now
                </a>
                <a href="tel:+919891979097" className="bg-green-700 text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-green-800 transition shadow-xl">Call: +91 9891 97 90 97</a>
              </div>
            </section>

            {/* Trust Signals */}
            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center">Trusted by 1,200+ Buyers</h2>
              <div className="grid md:grid-cols-4 gap-6 mb-6">
                <div className="bg-gradient-to-br from-brand-50 to-blue-50 p-6 rounded-xl text-center">
                  <div className="text-4xl font-bold text-brand-600 mb-2">520+</div>
                  <div className="text-gray-700 font-semibold">Properties Sold</div>
                </div>
                <div className="bg-gradient-to-br from-green-50 to-emerald-50 p-6 rounded-xl text-center">
                  <div className="text-4xl font-bold text-green-600 mb-2">₹280Cr+</div>
                  <div className="text-gray-700 font-semibold">Transaction Value</div>
                </div>
                <div className="bg-gradient-to-br from-yellow-50 to-orange-50 p-6 rounded-xl text-center">
                  <div className="text-4xl font-bold text-orange-600 mb-2">4.8/5</div>
                  <div className="text-gray-700 font-semibold">Rating</div>
                </div>
                <div className="bg-gradient-to-br from-purple-50 to-pink-50 p-6 rounded-xl text-center">
                  <div className="text-4xl font-bold text-purple-600 mb-2">7-15</div>
                  <div className="text-gray-700 font-semibold">Days to Close</div>
                </div>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-lg border-2 border-brand-100">
                <p className="text-gray-700 text-center"><strong>✅ Legally Verified</strong> | Zero Brokerage | Legal Support</p>
              </div>
            </section>

            {/* Quick Objections */}
            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Common Concerns Addressed</h2>
              <div className="space-y-4">
                <div className="bg-white p-6 rounded-xl shadow-md border-l-4 border-brand-500">
                  <h3 className="text-lg font-bold text-gray-900 mb-2">❓ Will I get market rate?</h3>
                  <p className="text-gray-700">Yes. Our AI analyzes 5,000+ transactions. You save 1-2% brokerage.</p>
                </div>
                <div className="bg-white p-6 rounded-xl shadow-md border-l-4 border-green-500">
                  <h3 className="text-lg font-bold text-gray-900 mb-2">❓ Why trust 99prop?</h3>
                  <p className="text-gray-700">520+ deals closed (₹280Cr+). Transparent pricing.</p>
                </div>
                <div className="bg-white p-6 rounded-xl shadow-md border-l-4 border-blue-500">
                  <h3 className="text-lg font-bold text-gray-900 mb-2">❓ Can I negotiate?</h3>
                  <p className="text-gray-700">Limited scope (2-3%). Already zero brokerage pricing.</p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Frequently Asked Questions</h2>
              <div className="space-y-6">
                {faqs.map((faq, index) => (
                  <div key={index} className="border-b border-gray-200 pb-6">
                    <h3 className="text-xl font-bold text-gray-900 mb-2">{faq.question}</h3>
                    <p className="text-gray-700 leading-relaxed">{faq.answer}</p>
                  </div>
                ))}
              </div>
            </section>

            <section className="bg-brand-500 p-8 rounded-xl text-center">
              <h2 className="text-3xl font-bold text-white mb-4">Ready to Buy Your 2BHK in Vasundhara?</h2>
              <p className="text-brand-100 text-lg mb-6">Zero brokerage. Direct deals. Expert advisory.</p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <button onClick={() => navigate('/buy-property')} className="bg-white text-brand-600 px-8 py-4 rounded-lg font-bold text-lg hover:bg-gray-100 transition shadow-xl">View Properties</button>
                <a href="tel:+919891979097" className="bg-brand-700 text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-brand-800 transition shadow-xl">Call: +91 9891 97 90 97</a>
              </div>
            </section>

          </article>
        </div>
      </div>
    </>
  );
};

export default Buy2BHKVasundharaPage;
